import { Constants } from "@global-mediation/globalmediation-core/Constants";
import { Case } from "@global-mediation/globalmediation-core/Server/Schema/Entities/Case.Generated";
import { CaseCancellationPostponement } from "@global-mediation/globalmediation-core/Server/Schema/Entities/CaseCancellationPostponement.Generated";
import { CaseMilestone } from "@global-mediation/globalmediation-core/Server/Schema/Entities/CaseMilestone.Generated";
import { CaseReferral } from "@global-mediation/globalmediation-core/Server/Schema/Entities/CaseReferral.Generated";
import { ClientSatisfactionQuestionnaire } from "@global-mediation/globalmediation-core/Server/Schema/Entities/ClientSatisfactionQuestionnaire.Generated";
import { EmailTemplate } from "@global-mediation/globalmediation-core/Server/Schema/Entities/EmailTemplate.Generated";
import { Enquiry } from "@global-mediation/globalmediation-core/Server/Schema/Entities/Enquiry.Generated";
import { MediationAdviceProtocol } from "@global-mediation/globalmediation-core/Server/Schema/Entities/MediationAdviceProtocol.Generated";
import { MediatorEvaluationForm } from "@global-mediation/globalmediation-core/Server/Schema/Entities/MediatorEvaluationForm.Generated";
import { Configuration } from "@seriously-rad/seriouslyrad-framework-core/Configuration";
import { DataSource } from "@seriously-rad/seriouslyrad-framework-core/Data/DataSource";
import { EntityCommandTypeEnum } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityManager } from "@seriously-rad/seriouslyrad-framework-core/EntityManager";
import { StringHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/StringHelper";
import { JNativeStatic } from "@seriously-rad/seriouslyrad-framework-core/JNative";
import { RadObject } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { WindowShim } from "@seriously-rad/seriouslyrad-framework-core/RadWindow";
import { registerCoreAsync, registerPageManagerConfiguration } from "@seriously-rad/seriouslyrad-framework-core/Registration";
import { nameof } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/Extensions";
import { ClientAwareEntityIdAttribute } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/ClientAwareEntityIdAttribute";
import { ClientAwareLookupItemAttribute } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/ClientAwareLookupItemAttribute";
import { BlockEditor } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/BlockEditor";
import { ChartColorSchemes } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/Chart/ColorSchemes";
import { CheckBoxListFlags } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/CheckBoxListFlags";
import { CheckBoxListLookupItem } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/CheckBoxListLookupItem";
import { CheckBoxListYesNo } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/CheckBoxListYesNo";
import { ComboBoxApplicationEntity } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ComboBoxApplicationEntity";
import { EntityPicker } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/EntityPicker";
import { FullPageLoader } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/FullPageLoader";
import { PropertyEditorNew } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/PropertyEditorNew";
import { Page } from "@seriously-rad/seriouslyrad-framework-core/Ui/Pages/Page";
import { registerModuleContactsAsync } from "@seriously-rad/seriouslyrad-framework-module-contacts/Registration";
import { registerModuleDocumentsAsync } from "@seriously-rad/seriouslyrad-framework-module-documents/Registration";
import { registerModuleFilesAsync } from "@seriously-rad/seriouslyrad-framework-module-files/Registration";
import { registerModuleIntegrationsAsync } from "@seriously-rad/seriouslyrad-framework-module-integrations/Registration";
import { registerModuleJobsAsync } from "@seriously-rad/seriouslyrad-framework-module-jobs/Registration";
import { registerModuleNotificationsAsync } from "@seriously-rad/seriouslyrad-framework-module-notifications/Registration";
import { ProcessItemServiceManager } from "@seriously-rad/seriouslyrad-framework-module-processes/ProcessItemServices/ProcessItemServiceManager";
import { registerModuleProcessesAsync } from "@seriously-rad/seriouslyrad-framework-module-processes/Registration";
import { registerModuleReportsAsync } from "@seriously-rad/seriouslyrad-framework-module-reports/Registration";
import { EntityCommandCaseClone } from "./EntityCommands/EntityCommandCaseClone";
import { EntityCommandCaseEmailFilter } from "./EntityCommands/EntityCommandCaseEmailFilter";
import { EntityCommandFlaggedCaseEmailFilter } from "./EntityCommands/EntityCommandFlaggedCaseEmailFilter";
import { EntityCommandFlaggedCaseEmailSelectCase } from "./EntityCommands/EntityCommandFlaggedCaseEmailSelectCase";
import { EntityCommandLocalAuthorityInvoiceRunFinalise } from "./EntityCommands/EntityCommandLocalAuthorityInvoiceRunFinalise";
import { EntityCommandProcessInstanceItemReopenCase } from "./EntityCommands/EntityCommandProcessInstanceItemReopenCase";
import { EntityCommandTeamMemberRemoveFromTeam } from "./EntityCommands/EntityCommandTeamMemberRemoveFromTeam";
import { EntityCommandUserDelete } from "./EntityCommands/EntityCommandUserDelete";
import { EntityCommandUserSetPassword } from "./EntityCommands/EntityCommandUserSetPassword";
import { CheckBoxListAgreeDisagree } from "./Ui/Controls/CheckBoxListAgreeDisagree";
import { EmailBlockEditor } from "./Ui/Controls/EmailBlockEditor";
import { HtmlViewer } from "./Ui/Controls/HtmlViewer";
import pageManagerConfiguration from "./Ui/PageManagerConfiguration";

const
    radWindow = WindowShim();

function registerProcessItemServices()
{
    ProcessItemServiceManager.add("66E11427-1C71-4073-8B8B-D9EC95F9FA4A", async () => new (await import("./ProcessItemServices/BookProvisionalMeetingProcessItemService")).BookProvisionalMeetingProcessItemService())
    ProcessItemServiceManager.add("14153374-9ECB-41BF-94F1-727FEC313DD0", async () => new (await import("./ProcessItemServices/ConfirmSencoProcessItemService")).ConfirmSencoProcessItemService())
    ProcessItemServiceManager.add("9C17F48F-12E0-4629-AED2-E382C774C7FA", async () => new (await import("./ProcessItemServices/EmailEntryProcessItemService")).EmailEntryProcessItemService())
    ProcessItemServiceManager.add("4CBECDCD-2D5C-4B09-82A2-5EA8DFA0EF8C", async () => new (await import("./ProcessItemServices/LaFeedbackOnParentProposedDatesProcessItemService")).LaFeedbackOnParentProposedDatesProcessItemService())
    ProcessItemServiceManager.add("3CA27B73-F368-4610-AEEA-BEFF5981A3F2", async () => new (await import("./ProcessItemServices/LaResponseProcessItemService")).LaResponseProcessItemService())
    ProcessItemServiceManager.add("90151448-F99C-470E-80C8-3321591F8990", async () => new (await import("./ProcessItemServices/LogCancellationPostponementProcessItemService")).LogCancellationPostponementProcessItemService())
    ProcessItemServiceManager.add("E9038C1D-D0D8-418D-AB2F-69232E6F53F1", async () => new (await import("./ProcessItemServices/MediationOutcomeProcessItemService")).MediationOutcomeProcessItemService())
    ProcessItemServiceManager.add("2D4F62BD-A8E4-4302-BEB0-F93B87CC0213", async () => new (await import("./ProcessItemServices/ParentResponseProcessItemService")).ParentResponseProcessItemService())
    ProcessItemServiceManager.add("B8E31449-94A5-4383-B617-B1224A63827D", async () => new (await import("./ProcessItemServices/PhoneParentsLaOfficerToAgreeDateProcessItemService")).PhoneParentsLaOfficerToAgreeDateProcessItemService())
    ProcessItemServiceManager.add("7419887E-C42D-43E1-ABD2-DD6E80FDF6B0", async () => new (await import("./ProcessItemServices/SelectMediatorProcessItemService")).SelectMediatorProcessItemService())
    ProcessItemServiceManager.add("D2EC7976-516F-4FC0-AA4C-39F66B95D09D", async () => new (await import("./ProcessItemServices/SelectVideoMeetingProcessItemService")).SelectVideoMeetingProcessItemService())
}

export async function registerAppAsync(configuration: Configuration)
{
    RadObject.registerPropertyDefaultOverride(Page, () => ({
        transitionName: "fadey",
    }));

    ChartColorSchemes["globalmediation"] = {
        one: ["#8441be", "#cb1d95", "#eb2361", "#eb552d", "#d18300", "#a4a700", "#5fc43b"],
        yesNo: ["#24eb24", "#eb2424"]
    };

    radWindow.entityManager = new EntityManager();
    radWindow.fullPageLoader = new FullPageLoader();

    await registerCoreAsync(configuration);
    await registerModuleContactsAsync(configuration);
    await registerModuleDocumentsAsync(configuration);
    await registerModuleFilesAsync(configuration);
    await registerModuleIntegrationsAsync(configuration);
    await registerModuleJobsAsync(configuration);
    await registerModuleNotificationsAsync(configuration);
    await registerModuleProcessesAsync(configuration);
    await registerModuleReportsAsync(configuration);

    JNativeStatic.ajaxSetup({
        timeout: null
    });

    radWindow.entityManager.removeCommand({ entityName: "Case", key: "SORT", type: EntityCommandTypeEnum.entitySet });
    radWindow.entityManager.removeCommand({ entityName: "CaseEmail", key: "NEW", type: EntityCommandTypeEnum.entitySet });
    radWindow.entityManager.registerCommand(new EntityCommandCaseClone());
    radWindow.entityManager.registerCommand(new EntityCommandCaseEmailFilter());
    radWindow.entityManager.registerCommand(new EntityCommandFlaggedCaseEmailFilter());
    radWindow.entityManager.registerCommand(new EntityCommandFlaggedCaseEmailSelectCase());
    radWindow.entityManager.registerCommand(new EntityCommandLocalAuthorityInvoiceRunFinalise());
    radWindow.entityManager.registerCommand(new EntityCommandProcessInstanceItemReopenCase());
    radWindow.entityManager.removeCommand({ entityName: "TeamMember", key: "DELETE", type: EntityCommandTypeEnum.entity });
    radWindow.entityManager.registerCommand(new EntityCommandTeamMemberRemoveFromTeam());
    radWindow.entityManager.registerCommand(new EntityCommandUserDelete());
    radWindow.entityManager.registerCommand(new EntityCommandUserSetPassword());

    PropertyEditorNew.registerEditorControlOverride(propertyInfo =>
    {
        switch (propertyInfo.typeInfo?.name)
        {
            case Case.name:
                {
                    switch (propertyInfo.name)
                    {
                        case nameof(Case, "ehcpContent"):
                            return new CheckBoxListFlags({ listDataSource: new DataSource({ data: Constants.MEF_EHCP_SECTIONS_IN_DISPUTE_LIST }), })
                    }

                    break;
                }
            case CaseCancellationPostponement.name:
                {
                    switch (propertyInfo.name)
                    {
                        case nameof(CaseCancellationPostponement, "meetingOutcomeComboDropDownId"):
                            {
                                const
                                    entityIdAttribute = propertyInfo.getAttribute(ClientAwareEntityIdAttribute);

                                if (entityIdAttribute)
                                {
                                    return new ComboBoxApplicationEntity({
                                        primaryEntity: entityIdAttribute.entityNamePlural,
                                        primaryEntityDescriptionProperty:
                                            entityIdAttribute.entityDescriptionProperty
                                                ? StringHelper.toLowerCamelCase(entityIdAttribute.entityDescriptionProperty)
                                                : null,
                                        primaryEntityFilter: "itemName eq 'Outcome'",
                                    });
                                }
                                break;
                            }
                    }

                    break;
                }
            case CaseMilestone.name:
                {
                    switch (propertyInfo.name)
                    {
                        case nameof(CaseMilestone, "tracks"):
                            return new CheckBoxListFlags({ listDataSource: new DataSource({ data: Constants.TRACK_LIST }), });
                    }

                    break;
                }
            case CaseReferral.name:
                {
                    switch (propertyInfo.name)
                    {
                        case nameof(CaseReferral, "officerLocalAuthorityGroupStaffMemberId"):
                            {
                                return new EntityPicker({
                                    entityName: "LocalAuthorityGroupStaffMember",
                                    entityNameFriendly: "Local Authority Group Staff Member",
                                    entitySetName: "LocalAuthorityGroupStaffMembers",
                                    entitySetNameFriendly: "Local Authority Group Staff Members",
                                    entityDescriptionProperty: "fullName",
                                    entityFilter: "localAuthorityGroup/localAuthorities/any(item1:item1/cases/any(item2:item2/id eq [caseId])) and (localAuthorityId eq null or localAuthority/cases/any(item3:item3/id eq [caseId]))",
                                });
                            }
                    }

                    break;
                }
            case ClientSatisfactionQuestionnaire.name:
                {
                    const
                        lookupItemAttribute = propertyInfo.getAttribute(ClientAwareLookupItemAttribute);

                    if (lookupItemAttribute && lookupItemAttribute.typeDescription === "CSQ Agree / Disagree Ratings")
                        return new CheckBoxListAgreeDisagree();

                    switch (propertyInfo.name)
                    {
                        case nameof(ClientSatisfactionQuestionnaire, "sourceLookupItemId"):
                            {
                                const
                                    lookupItemAttribute = propertyInfo.getAttribute(ClientAwareLookupItemAttribute);

                                if (lookupItemAttribute)
                                    return new CheckBoxListLookupItem({ lookupType: lookupItemAttribute.typeDescription, });

                                break;
                            }
                        case nameof(ClientSatisfactionQuestionnaire, "canContact"):
                        case nameof(ClientSatisfactionQuestionnaire, "canShareFeedback"):
                        case nameof(ClientSatisfactionQuestionnaire, "canUseNameOrOrganisationsName"):
                            {
                                return new CheckBoxListYesNo();
                            }
                    }

                    break;
                }
            case EmailTemplate.name:
                {
                    switch (propertyInfo.name)
                    {
                        case nameof(EmailTemplate, "body"):
                            return new EmailBlockEditor();
                    }

                    break;
                }
            case Enquiry.name:
                {
                    switch (propertyInfo.name)
                    {
                        case nameof(Enquiry, "bestCallTimeframe"):
                            return new CheckBoxListFlags({ listDataSource: new DataSource({ data: Constants.ENQUIRY_TELEPHONE_CALL_TIMESLOT_LIST }), })
                        case nameof(Enquiry, "ehcpContent"):
                            return new CheckBoxListFlags({ listDataSource: new DataSource({ data: Constants.MEF_EHCP_SECTIONS_IN_DISPUTE_LIST_SUPPORTED }), })
                    }

                    break;
                }
            case MediationAdviceProtocol.name:
                {
                    switch (propertyInfo.name)
                    {
                        case nameof(MediationAdviceProtocol, "protocolHtml"):
                            return new BlockEditor();
                    }

                    break;
                }
            case MediatorEvaluationForm.name:
                {
                    const
                        entityIdAttribute = propertyInfo.getAttribute(ClientAwareEntityIdAttribute);

                    switch (propertyInfo.name)
                    {
                        case nameof(MediatorEvaluationForm, "caseId"):
                            {
                                if (entityIdAttribute)
                                {
                                    return new EntityPicker({
                                        entityName: entityIdAttribute.entityName,
                                        entityNameFriendly: entityIdAttribute.entityNameFriendly,
                                        entitySetName: entityIdAttribute.entityNamePlural,
                                        entitySetNameFriendly: entityIdAttribute.entityNamePluralFriendly,
                                        entityDescriptionProperty:
                                            entityIdAttribute.entityDescriptionProperty
                                                ? StringHelper.toLowerCamelCase(entityIdAttribute.entityDescriptionProperty)
                                                : null,
                                        textBoxSearchTitle: "Enter a case reference or child / young person surname"
                                    });
                                }
                            }
                        case nameof(MediatorEvaluationForm, "errorsInReferralSummaryOrNoticeOfArrangementsLookupItemId"):
                            return new CheckBoxListFlags({ listDataSource: new DataSource({ data: Constants.MEF_ERRORS_IN_REFERRAL_SUMMARY_OR_NOTICE_OF_ARRANGEMENT_LIST }), })
                        case nameof(MediatorEvaluationForm, "heathAndSocialCare"):
                            return new CheckBoxListFlags({ listDataSource: new DataSource({ data: Constants.MEF_HEALTH_AND_SOCIAL_CARE_LIST }), })
                        case nameof(MediatorEvaluationForm, "ehcpSectionsInDispute"):
                            return new CheckBoxListFlags({ listDataSource: new DataSource({ data: Constants.MEF_EHCP_SECTIONS_IN_DISPUTE_LIST }), })
                        case nameof(MediatorEvaluationForm, "meetingAttendees"):
                            return new CheckBoxListFlags({ listDataSource: new DataSource({ data: Constants.MEF_MEETING_ATTENDEES_LIST }), })
                        case nameof(MediatorEvaluationForm, "confirmationDocumentsReceivedLookupItemId"):
                        case nameof(MediatorEvaluationForm, "caseTypeLookupItemId"):
                        case nameof(MediatorEvaluationForm, "preMediationWorkLengthLookupItemId"):
                        case nameof(MediatorEvaluationForm, "mediationMeetingLengthLookupItemId"):
                        case nameof(MediatorEvaluationForm, "howViewsOfCypMadeKnownLookupItemId"):
                        case nameof(MediatorEvaluationForm, "whyCypDidNotAttendReasonLookupItemId"):
                        case nameof(MediatorEvaluationForm, "attendeesProvidedCsqFormLookupItemId"):
                        case nameof(MediatorEvaluationForm, "mediationOutcomeLookupItemId"):
                            {
                                const
                                    lookupItemAttribute = propertyInfo.getAttribute(ClientAwareLookupItemAttribute);

                                if (lookupItemAttribute)
                                    return new CheckBoxListLookupItem({ lookupType: lookupItemAttribute.typeDescription, });

                                break;
                            }
                    }

                    break;
                }
        }

        return undefined;
    });
    PropertyEditorNew.registerViewControlOverride(propertyInfo =>
    {
        if (propertyInfo.typeInfo?.name === EmailTemplate.name)
        {
            switch (propertyInfo.name)
            {
                case nameof(EmailTemplate, "body"):
                    return new HtmlViewer();
            }
        }
        if (propertyInfo.typeInfo?.name === MediationAdviceProtocol.name)
        {
            switch (propertyInfo.name)
            {
                case nameof(MediationAdviceProtocol, "protocolHtml"):
                    return new HtmlViewer();
            }
        }

        return undefined;
    });

    registerProcessItemServices();
    registerPageManagerConfiguration(configuration, pageManagerConfiguration);
}